var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchnelleTiefenreinigung = function SvgSchnelleTiefenreinigung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Schnelle_Tiefenreinigung_svg__Ebene_2",
    viewBox: "0 0 108.61 108.68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Schnelle_Tiefenreinigung_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schnelle_Tiefenreinigung_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.31 0c0 29.99 24.34 54.34 54.31 54.34-29.97 0-54.31 24.35-54.31 54.34 0-29.99-24.34-54.34-54.31-54.34 30.02 0 54.31-24.35 54.31-54.34Z",
    className: "Schnelle_Tiefenreinigung_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71 11.93c0 6.98 5.48 12.65 12.23 12.65-6.75 0-12.23 5.67-12.23 12.65 0-6.98-5.48-12.65-12.23-12.65 6.76 0 12.23-5.67 12.23-12.65Z",
    className: "Schnelle_Tiefenreinigung_svg__cls-1"
  }))));
};
export default SvgSchnelleTiefenreinigung;